export enum Sizes {
  largeDesktop = 1300,
  desktop = 768,
  tablet = 576,
  phone = 375,
}
